import { PageHero } from "./Services";

const TEAM_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_castle-ops-1/artifacts/tonopt8p_11.png";

export default function About() {
  return (
    <div>
      <PageHero overline="About Us" title="We don't just provide services. We elevate experiences."
        sub="CastleCorp is dedicated to the pursuit of excellence in all that we represent — premium services, relentless innovation, uncompromising standards." />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="overline-cc mb-3">The Standard</p>
          <h2 className="font-heading font-bold text-3xl tracking-tight">Built like a company that intends to scale nationally.</h2>
          <div className="mt-6 space-y-5 text-muted-foreground leading-relaxed text-[15px]">
            <p>CastleCorp began with a simple observation: the service industry runs on chaos — vague arrival windows, hourly billing that punishes efficiency, crews with no accountability. We built the opposite.</p>
            <p>Every job at CastleCorp is a mission: numbered, planned, assigned to a vetted crew and a specific vehicle, tracked from dispatch to sign-off. Our customers see the same operational picture our command center sees.</p>
            <p>From AI-powered business optimization and professional white-glove moving & delivery to furniture assembly and junk removal, every division is built with the same client-first discipline: quality, reliability, and precision.</p>
          </div>
        </div>
        <div className="rounded-2xl overflow-hidden border card-lift bg-[#050607]">
          <img src={TEAM_IMG} alt="CastleCorp — insignia" className="w-full h-[420px] object-contain p-8" />
        </div>
      </section>
      <section className="border-y bg-secondary/40">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-2 lg:grid-cols-4 gap-8">
          {[["1,200+", "Missions Executed"], ["98.6%", "On-Time Rate"], ["$1M", "Insurance Coverage"], ["4.9★", "Average Rating"]].map(([v, l]) => (
            <div key={l}>
              <p className="font-heading font-extrabold text-4xl tracking-tight text-[var(--cc-accent)]">{v}</p>
              <p className="mt-1 text-sm text-muted-foreground">{l}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-20">
        <p className="overline-cc mb-3">Principles</p>
        <h2 className="font-heading font-bold text-3xl tracking-tight mb-12">What we operate on.</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            ["Precision", "Every mission is planned to the minute — crew, vehicle, route, timeline. Improvisation is a failure mode."],
            ["Discipline", "Uniformed, trained, background-checked operatives. We show up early and leave the site cleaner than we found it."],
            ["Transparency", "Flat rates, live tracking, and a portal that shows you exactly what our operations center sees."],
          ].map(([t, d]) => (
            <div key={t} className="rounded-xl border bg-card p-8 card-lift">
              <h3 className="font-heading font-semibold text-xl">{t}</h3>
              <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
